import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Number from "csi/heading/Number";
import csi from "csi/main";
import declare from "dojo/_base/declare";

const DEFAULT_AMOUNT: number = -999.0;

const AmountPer100GM = declare(Number, {
	blankValue: DEFAULT_AMOUNT,

	/**
	 * @override
	 * Handle default value (-999)
	 */
	formatValue(value: any, fmt: string) {
		return value == DEFAULT_AMOUNT ? csi.EMPTY_STRING : this.inherited(arguments);
	},

	/**
	 * @override
	 * When user clear the cell, new value is default (-999)
	 */
	fromHtmlDynamic(ctx: Context, h: Heading, editNode: any) {
		return (this.getEditorValue(ctx, editNode) === csi.EMPTY_STRING) ? DEFAULT_AMOUNT : this.inherited(arguments);
	},

	/**
	 * @override
	 * NutrientItem's AmountPer100GM & CalculatedAmountPer100GM value should be displayed as empty if the value is -999 (C8-37073, C8-37800)
	 */
	toValue(ctx: Context, h: Heading) {
		return this._getValue(ctx, h) == DEFAULT_AMOUNT ? csi.EMPTY_STRING : this.inherited(arguments);
	},

	/**
	 * @override
	 * On edit of NutrientItem's AmountPer100GM : display default (-999.0) as blank (C8-37073)
	 */
	toValueDynamic(ctx: Context, h: Heading, v: number) {
		const value = (v == null) ? this._getValue(ctx, h) : v;
		return (value == DEFAULT_AMOUNT) ? csi.EMPTY_STRING : this.inherited(arguments);
	},

});

export = AmountPer100GM;